import { render, staticRenderFns } from "./PermEdit.vue?vue&type=template&id=68657c16&scoped=true"
import script from "./PermEdit.vue?vue&type=script&lang=js"
export * from "./PermEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68657c16",
  null
  
)

export default component.exports